import type { StrategyLayer, StrategyLayerKind } from "@/types/strategy";

export function strategyChoiceKey(
  kind: StrategyLayerKind,
  params: Record<string, number> = {},
): string {
  if (kind === "single_call") {
    return (params.side ?? 1) < 0 ? "short_call" : "long_call";
  }
  if (kind === "single_put") {
    return (params.side ?? 1) < 0 ? "short_put" : "long_put";
  }
  return kind;
}

export function strategyLayerChoiceKey(layer: StrategyLayer): string {
  return strategyChoiceKey(layer.kind, layer.params);
}
